import React, { useState } from 'react';
import logoNav from '../../images/logo_albo.svg';

export const Banner = () => {
	return (

		<div className="hero">
			<div className="nav">
                <img src={logoNav} alt="albo logo" />
			</div>
			<div className="portada">
				<div className="informacion">
				</div>
			</div>
		</div>

		
	);
	
};
